import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle2, XCircle, Clock } from 'lucide-react';

const PaymentResult = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const status = params.get('status') || 'Unknown';
  const paid = status === 'Paid';
  const pending = status === 'Pending';
  const Icon = paid ? CheckCircle2 : pending ? Clock : XCircle;

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center pt-16 px-4" data-testid="payment-result-page">
      <Card className="border-0 shadow-xl max-w-md w-full">
        <CardContent className="p-8 text-center">
          <Icon className={`w-16 h-16 mx-auto mb-4 ${paid ? 'text-green-500' : pending ? 'text-amber-500' : 'text-red-500'}`} />
          <h1 className="text-2xl font-bold text-gray-900 mb-2" data-testid="payment-result-title">
            {paid ? 'Payment successful' : pending ? 'Payment pending' : 'Payment not completed'}
          </h1>
          <p className="text-gray-600 mb-2" data-testid="payment-result-status">Status: {status}</p>
          {params.get('amount_kwd') && <p className="text-gray-600 mb-2">Amount: KD {params.get('amount_kwd')}</p>}
          {params.get('order_id') && <p className="text-xs text-gray-400 font-mono mb-6">{params.get('order_id')}</p>}
          {params.get('detail') && <p className="text-sm text-red-600 mb-4">{params.get('detail')}</p>}
          <div className="flex gap-3 justify-center">
            <Button data-testid="payment-result-bookings-btn" onClick={() => navigate('/my-bookings')} className="bg-gradient-to-r from-teal-500 to-cyan-600 text-white">My Bookings</Button>
            {!paid && <Button variant="outline" onClick={() => navigate('/contact')} className="border-2">Need help?</Button>}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentResult;
